import * as React from "react";
import { forwardRef } from "react";
const DocumentIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "data-category": "documentation",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.75 1.5c-.19891 0-.38968.07902-.53033.21967S3 2.05109 3 2.25v19.5c0 .1989.07902.3897.21967.5303.14065.1407.33142.2197.53033.2197h16.5c.1989 0 .3897-.079.5303-.2197.1407-.1406.2197-.3314.2197-.5303V8.12116c0-.00005 0 .00005 0 0-.0001-.19864-.079-.38929-.2193-.52983-.0001-.00006 0 .00006 0 0L14.9088 1.7195c-.1405-.14047-.3311-.21942-.5298-.2195-.0001 0 .0001 0 0 0zM2.15901.65901C2.58097.237053 3.15326 0 3.75 0h10.629c.5963.00012732 1.1684.236973 1.5902.6585l5.8721 5.87217c.4216.4218.6586.99385.6587 1.59017V21.75c0 .5967-.2371 1.169-.659 1.591-.422.4219-.9943.659-1.591.659H3.75c-.59674 0-1.16903-.2371-1.59099-.659C1.73705 22.919 1.5 22.3467 1.5 21.75V2.25c0-.59674.23705-1.16903.65901-1.59099",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.25 0c.4142 0 .75.335786.75.75v6c0 .19891.079.38968.2197.53033.1406.14065.3314.21967.5303.21967h6c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-6c-.5967 0-1.169-.23705-1.591-.65901-.4219-.42196-.659-.99425-.659-1.59099v-6c0-.414214.3358-.75.75-.75m-8 15c0-.4142.33579-.75.75-.75h11c.4142 0 .75.3358.75.75s-.3358.75-.75.75H7c-.41421 0-.75-.3358-.75-.75m0-4c0-.4142.33579-.75.75-.75h6c.4142 0 .75.3358.75.75s-.3358.75-.75.75H7c-.41421 0-.75-.3358-.75-.75m0-4c0-.41421.33579-.75.75-.75h3.5c.4142 0 .75.33579.75.75s-.3358.75-.75.75H7c-.41421 0-.75-.33579-.75-.75M6 19.5c0-.4142.33579-.75.75-.75H18c.4142 0 .75.3358.75.75s-.3358.75-.75.75H6.75c-.41421 0-.75-.3358-.75-.75",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(DocumentIcon);
ForwardRef.category = "documentation";
export { ForwardRef as DocumentIcon };